import { getRailsEnv } from '@opendoor/shared-fe/build/railsEnv';

const railsEnv = getRailsEnv();

const useStaging = process.env.REACT_APP_ATHENA_URL?.includes('staging');

const env = useStaging ? 'staging' : railsEnv;
export const RAILS_ENV = env;
export const offerPollingTimeoutThreshold = env === 'production' ? 90_600 : 120_000;
export const backendRefreshBlockDurationMS = 120_000;

export const HOMEPAGE_URL = {
  production: 'https://www.opendoor.com',
  staging: 'https://demo.simplersell.com',
  qa: 'https://demo.simplersell.com',
  development: 'http://localhost:3011/homepage-2019',
  test: 'https://www.opendoor.com',
}[env];
